import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  () => ({
    root: {
      padding: 0,
    },
    paper: {
      overflow: 'hidden',
      width: 1000,
      maxWidth: 1000,
      height: 600,
      maxHeight: 600,
    },
    dialogContent: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 !important',
    },
    leftBlockImg: {
      marginTop: -80,
      marginLeft: 20,
    },
    submitButton: {
      position: 'absolute',
      bottom: 45,
      left: 45,
      borderRadius: 50,
    },
  }),
  { name: 'WelcomeRetrialPopup' }
);
